import React, { ComponentProps } from "react";
import cls from "classnames";

const UnitOfMeasure = ({
  className,
  children,
  ...rest
}: ComponentProps<"span">) => (
  <span className={cls("font-bold", className)} {...rest}>
    /{children}
  </span>
);

export default UnitOfMeasure;
